import { Component, Input, OnInit } from '@angular/core';
import { TranslateService }         from '@ngx-translate/core';
import { UIRouter }                 from '@uirouter/core';

import { CompanyService }         from '../companies/company.service';
import { MessagesService }        from '../messages/messages.service';
import { QuickbooksService }      from '../quickbooks/quickbooks.service';
import { QuickbooksTaxRateModel } from '../quickbooks/typings/quickbooks.tax-rate';
import { TaxGroupModel }          from './typings/tax-group';
import { TaxGroupsService }       from './tax-groups.service';
import { XeroService }            from '../xero/xero.service';
import { XeroTaxRateModel }       from '../xero/models/xero.tax-rate';

@Component({
  selector   : 'wor-tax-groups',
  template: require('./tax-groups.component.html')
})
export class TaxGroupsComponent implements OnInit {
  @Input() groups      : Array<TaxGroupModel> = [];

  public quickbooksTaxRates : Array<QuickbooksTaxRateModel> = [];
  public xeroTaxRates       : Array<XeroTaxRateModel>       = [];

  constructor (
    public  companyService   : CompanyService,
    private messagesService  : MessagesService,
    private quickbooksService: QuickbooksService,
    private router           : UIRouter,
    private taxGroupsService : TaxGroupsService,
    private translateService : TranslateService,
    private xeroService      : XeroService
  ) {}

  ngOnInit () : void {
    if (this.companyService.hasIntegration('xero')) {
      this.xeroService.getTaxRates()
      .then(( rates : Array<XeroTaxRateModel> ) => {
        this.xeroTaxRates = rates;
      })
      .catch(( err : any ) => {
        this.messagesService.error(err);
      });
    }
    else if (this.companyService.hasIntegration('quickbooks')) {
      this.quickbooksService.getTaxRates()
      .then(( rates : Array<QuickbooksTaxRateModel> ) => {
        this.quickbooksTaxRates = rates;
      })
      .catch(( err : any ) => {
        this.messagesService.error(err);
      });
    }
  }

  add () : void {
    this.groups.push({
      name                      : '',
      tax_group_items_attributes: []
    });

    this.groups[ this.groups.length - 1 ]
    .tax_group_items_attributes
    .push({
      tax_type      : '',
      labor_gst_free: false,
      editing       : true
    });
  }

  delete ( index : number ) : void {
    if ( this.groups[ index ].id ) {
      this.taxGroupsService.delete(this.groups[ index ])
      .then(() => {
        this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.DELETED.GROUP'), 'success');

        this.router.stateService.reload();
      })
      .catch(error => this.messagesService.error(error));
    } else {
      this.groups.splice(index, 1);
    }
  }
}
